import Stack from '@mui/material/Stack'
import React, { useEffect } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import SourceLoading from './SourceLoading'
import { carouselIconsState } from '../state/brands'
import isFirstLoadingState from '../state/isFirstLoading'

const LoadingSources: React.FC = () => {
  const carouselIcons = useRecoilValue(carouselIconsState)
  const setIsFirstLoading = useSetRecoilState(isFirstLoadingState)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsFirstLoading(false)
    }, 5000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Stack
      direction="row"
      justifyContent="center"
      gap={{ xs: 3, sm: 6 }}
      sx={{
        flexWrap: 'wrap',
        margin: 'auto',
        width: { xs: '100%', sm: 550 },
        maxWidth: { xs: 550, sm: 'unset' },
        paddingY: { xs: 3, sm: 6 },
        paddingX: { xs: 0, sm: 3 }
      }}
    >
      {carouselIcons.map(item => (
        <SourceLoading key={item.id} source={item.slug} />
      ))}
    </Stack>
  )
}

export default LoadingSources
